// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"XL4vJynR46LvEVV5al9RN"};